const sdkInitType = 'react';
window.__SOLIDGATE_PRIVATE__SDK_INIT_TYPE = sdkInitType;
export {};
//# sourceMappingURL=index.js.map